export default "# Level 1 Heading\n## Level 2 Heading\n### Level 3 Heading\n#### Level 4 Heading\n##### Level 5 Heading\n###### Level 6 Heading\n";